<p-button
  (onClick)="displayMenu($event)"
  icon="pi pi-user"
  severity="secondary"
  rounded
/>
<p-popover #op styleClass="my-popover" (onHide)="onHidePopover()">
  <ng-template #content>
    <div class="rounded flex flex-col">
      <div class="pt-2">
        <div class="flex flex-row justify-between items-start gap-2 mb-4">
          <app-user-infos />
        </div>
        <div class="flex">
          <p-button
            icon="pi pi-sign-out"
            [label]="'NAVBAR.MENU.LOGOUT' | translate"
            class="flex-auto"
            styleClass="w-full whitespace-nowrap"
            (onClick)="onLogout()"
            severity="danger"
          />
        </div>
      </div>
    </div>
  </ng-template>
</p-popover>
